import api from '../utils/api';

const uuid = require('uuid/v4');

export default {
    namespaced: true,
    state: {
        profileConnections: [],
        datastoreConnections: [],
    },
    getters: {
        profileConnections(state) {
            return state.profileConnections;
        },
        datastoreConnections(state) {
            return state.datastoreConnections;
        },
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        PROFILE_CONNECTIONS(state, data) {
            state.profileConnections = data || [];
        },
        PROFILE_CONNECTION(state, data) {
            let replaced = false;
            for (let i = 0; i < state.profileConnections.length; i += 1) {
                if (state.profileConnections[i].ProfileProviderId === data.ProfileProviderId) {
                    state.profileConnections[i] = data;
                    replaced = true;
                }
            }
            if (!replaced) {
                if (state.profileConnections) {
                    state.profileConnections.push(data);
                } else {
                    state.profileConnections = [data];
                }
            }
        },
        DATASTORE_CONNECTIONS(state, data) {
            state.datastoreConnections = data || [];
        },
        DATASTORE_CONNECTION(state, data) {
            let replaced = false;
            for (let i = 0; i < state.datastoreConnections.length; i += 1) {
                if (state.datastoreConnections[i].DataStoreProviderId
                        === data.DataStoreProviderId) {
                    state.datastoreConnections[i] = data;
                    replaced = true;
                }
            }
            if (!replaced) {
                if (state.datastoreConnections) {
                    state.datastoreConnections.push(data);
                } else {
                    state.datastoreConnections = [data];
                }
            }
        },
        AUTHORIZE_CONNECTION(state, data) {
            const provider = data.provider;
            const type = data.type;
            const connectionState = uuid();
            const baseUrl = provider.AuthorizeUrl.replace('https://me.nowyu.com', decodeURI(location.origin));
            const url = `${baseUrl}&state=${connectionState}`;
            const redirectUri = provider.RedirectUri.replace('https://me.nowyu.com', decodeURI(location.origin));

            localStorage.setItem(`oauth.${provider.Code}`, JSON.stringify({ Type: type, State: connectionState, RedirectUri: redirectUri }));

            window.location = url;
        },
    },
    actions: {
        LIST_PROFILE_CONNECTIONS(context) {
            return api
                .get('/profile/profile_connections')
                .then(response => context.commit('PROFILE_CONNECTIONS', response.data))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
        LIST_DATASTORE_CONNECTIONS(context) {
            return api
                .get('/profile/datastore_connections')
                .then(response => context.commit('DATASTORE_CONNECTIONS', response.data))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
        SAVE_CONNECTION(context, data) {
            if (data.Query.error) {
                throw Error(data.Query.error_description, data.Query.error);
            }

            const session = JSON.parse(localStorage.getItem(`oauth.${data.ProviderId}`));
            if (!session) {
                throw new Error(`No session authorization information found for ${data.ProviderId}`);
            }

            const connection = data.Query;
            if (!connection.state && connection.state !== session.State) {
                throw new Error(`Invalid session authorization information found for ${data.ProviderId}`);
            }

            connection.DataOwnerId = context.rootGetters['auth/userId'];
            connection.RedirectUri = session.RedirectUri;
            connection.State = session.State;

            let url;
            switch (session.Type) {
            case 'profile':
                connection.ProfileProviderId = data.ProviderId;
                url = 'profile/profile_connections';
                break;
            case 'datastore':
                connection.DataStoreProviderId = data.ProviderId;
                url = 'profile/datastore_connections';
                break;
            default:
                throw new Error(`unknow provider type! was ${data.ProviderType}`);
            }

            return api
                .put(url, connection)
                .then(response => context.commit('DATASTORE_CONNECTION', response.data))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
        AUTHORIZE_DATASTORE_CONNECTION(context, provider) {
            context.commit('AUTHORIZE_CONNECTION', { provider: provider, type: 'datastore' });
        },
        AUTHORIZE_PROFILE_CONNECTION(context, provider) {
            context.commit('AUTHORIZE_CONNECTION', { provider: provider, type: 'profile' });
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/profile.js